





















import {defineComponent, onMounted, onUnmounted, PropType, ref} from "@vue/composition-api";
import {useGetters, useMutations} from "vuex-composition-helpers";
import {IPaperclipConfig} from "@/apps/PaperclipWidget/models/paperclip-widget-state";

export default defineComponent({
  name: "PaperclipWidget",
  props: {
    config: {type: Object as PropType<IPaperclipConfig>, required: true}
  },
  setup: () => {
    const {isCollapsed} = useGetters(['isCollapsed'])
    const {toggleCollapsed} = useMutations(['toggleCollapsed'])

    const paperclip = ref<HTMLElement | null>(null);

    onMounted(() => {
      window.addEventListener("resize", keepInViewport);
      keepInViewport();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", keepInViewport);
    });

    function keepInViewport() {
      const element = paperclip.value as HTMLElement;
      // Reset the right property to make sure it has its original value
      element.style.right = "";

      // Don't do anything if the viewport is smaller than 910 points
      const viewportWidth = window.innerWidth;
      if (viewportWidth <= (910)) {
        return;
      }

      // When the element is outside the viewport, move it back inside
      if (element.getBoundingClientRect().right > viewportWidth) {
        // 6.11rem is the width of the paperclip
        element.style.right = "6.11rem";
      }
    }

    return {
      paperclip,
      isCollapsed,
      toggleCollapsed
    }
  }
})
